import { Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SummaryRowBox = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 14,
  padding: '16px 18px',
  borderRadius: 12,
  background: 'var(--am-surface)',
  border: '1px solid var(--am-border)',
});

export const SummaryRowIcon = styled(Box)({
  width: 34,
  height: 34,
  borderRadius: 9,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 16,
  background: 'var(--am-surface-2)',
  border: '1px solid var(--am-border)',
});

export const SummaryRowContent = styled(Box)({
  flex: 1,
  minWidth: 0,
});

export const SummaryRowLabel = styled(Typography)({
  fontSize: '11px',
  fontWeight: 700,
  lineHeight: '20px',
  color: 'var(--am-label-color)',
  letterSpacing: '0.07em',
  textTransform: 'uppercase',
  marginBottom: 4,
}) as typeof Typography;

export const SummaryRowValue = styled(Typography)({
  fontSize: '13px',
  fontWeight: 700,
  lineHeight: '20px',
  color: 'var(--am-text-primary)',
}) as typeof Typography;

export const SummaryRowDetail = styled(Typography)({
  fontSize: '13px',
  color: 'var(--am-text-secondary)',
  marginTop: 3,
  lineHeight: 1.5,
}) as typeof Typography;

export const SummaryRowEditButton = styled(Button)({
  fontSize: '13px',
  textTransform: 'none',
  borderRadius: 8,
  padding: '4px 12px',
  minWidth: 'unset',
  flexShrink: 0,
  color: 'var(--am-text-primary)',
  border: '1.5px solid var(--am-border-mid)',
  '&:hover': {
    borderColor: 'var(--am-focus-border-color)',
    color: 'var(--am-focus-border-color)',
    backgroundColor: 'transparent',
  },
});
